import React from 'react';
import { Link } from 'react-router-dom';
import usePageTranslation from '../../../shared/hooks/usePageTranslation';
import LegalPage from '../components/LegalPage';
import LegalSection from '../components/LegalSection';
import LegalContactBlock from '../components/LegalContactBlock';

const ConditionsUtilisation: React.FC = () => {
  const { t, loading } = usePageTranslation('public', 'ConditionsUtilisation');

  if (loading) return null;

  return (
    <LegalPage
      title={t('title')}
      subtitle={t('subtitle')}
      lastUpdate={t('lastUpdate')}
      lastUpdateDate={t('lastUpdateDate')}
    >
      <LegalSection number={1} title={t('acceptance.title')}>
        <p className="text-lg text-gray-300">{t('acceptance.description')}</p>
      </LegalSection>

      <LegalSection number={2} title={t('service.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('service.description')}</p>
        <ul className="space-y-2">
          {t('service.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={3} title={t('account.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('account.description')}</p>
        <ul className="space-y-2">
          {t('account.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={4} title={t('invitation.title')}>
        <p className="text-lg text-gray-300">{t('invitation.description')}</p>
      </LegalSection>

      <LegalSection number={5} title={t('conduct.title')}>
        <p className="text-lg text-gray-300 mb-4">{t('conduct.description')}</p>
        <ul className="space-y-2">
          {t('conduct.items').map((item: string, index: number) => (
            <li key={index} className="flex items-start text-gray-300">
              <span className="text-primary-400 font-bold mr-2">•</span>
              {item.includes('Règlement') || item.includes('Rules') ? (
                <span>
                  {item.split(/Règlement|Rules/)[0]}
                  <Link to="/legal/reglement" className="text-primary-400 hover:text-primary-300 underline">
                    {item.includes('Règlement') ? 'Règlement' : 'Rules'}
                  </Link>
                  {item.split(/Règlement|Rules/)[1]}
                </span>
              ) : (
                item
              )}
            </li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection number={6} title={t('content.title')}>
        <p className="text-lg text-gray-300">{t('content.description')}</p>
      </LegalSection>

      <LegalSection number={7} title={t('intellectual.title')}>
        <p className="text-lg text-gray-300">{t('intellectual.description')}</p>
      </LegalSection>

      <LegalSection number={8} title={t('liability.title')}>
        <p className="text-lg text-gray-300">{t('liability.description')}</p>
      </LegalSection>

      <LegalSection number={9} title={t('modifications.title')}>
        <p className="text-lg text-gray-300">{t('modifications.description')}</p>
      </LegalSection>

      <LegalSection number={10} title={t('termination.title')}>
        <p className="text-lg text-gray-300">{t('termination.description')}</p>
      </LegalSection>

      <LegalSection number={11} title={t('changes.title')}>
        <p className="text-lg text-gray-300">{t('changes.description')}</p>
      </LegalSection>

      <LegalSection number={12} title={t('contact.title')}>
        <LegalContactBlock
          description={t('contact.description')}
          discord={t('contact.discord')}
          discordAction={t('contact.discordAction')}
          email={t('contact.email')}
          owner={t('contact.owner')}
        />
      </LegalSection>
    </LegalPage>
  );
};

export default ConditionsUtilisation;
